import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Itinerary } from 'src/app/assabil-kernel/models/entities/master-data/itinerary-entity';
import { PartnerLovComponent } from '../partner-lov/partner-lov.component';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Field } from 'src/app/tools/models/dtos/field';
import { BranchLovComponent } from '../../../control-tables/branch/branch-lov/branch-lov.component';

@Component({
    selector: 'itinerary-list',
    templateUrl: './itinerary-list.component.html',
    styleUrls: ['./itinerary-list.component.scss']
})


export class ItineraryListComponent extends BasePage2<Itinerary> {

    itineraries : Itinerary[] = [];
    code        : string;
    name        : string;
    branchCode  : string;

    constructor(
        protected toastr                : ToastrService,
        protected controlTablesService  : ControlTablesService,
        protected masterDataService     : MasterDataService,
        protected router                : Router,
        protected baseService           : BaseService,
        protected leanUtilsService      : LeanUtilsService, 
        protected location              : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'itinerary';
    }

//----------------------------------------------------------------------
ngAfterViewInit(): void {
    super.ngAfterViewInit();
      this.setChildFields();
  }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
setChildFields(){
    this.baseService.fieldsGet('itineraryPartner').then(result => {
          this.childFields = result.listFields;

          this.childFields.forEach( field => {
            if (field.prop == 'partner') {
                field.modal = PartnerLovComponent;
            }
          })
 
    }) 
}
//----------------------------------------------------------------------



//----------------------------------------------------------------------
getRows(): Itinerary[] {
    return this.itineraries;
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
new(){
    let itinerary : Itinerary = new Itinerary();
    itinerary.inserted = true;
    itinerary.edit = true;
    this.selectedRow = itinerary;
}  
//----------------------------------------------------------------------


//----------------------------------------------------------------------
loadData() {
    this.masterDataService.itinerarysGet(this.code, this.name, this.branchCode).then(result => {
        this.itineraries = result;
    });
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
 selectRow(itinerary : Itinerary){
    this.masterDataService.itineraryGet(itinerary.itineraryCode).then(itinerary => {
        this.selectedRow = itinerary;
    })
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
 enrichField(field : Field){
    if (field.prop == 'branch') {
        field.modal = BranchLovComponent;
    }
 }
//----------------------------------------------------------------------

}
